"use strict";

import Vue from "vue";
import axios from "axios";
import VueCookies from "vue-cookies";

// Full config:  https://github.com/axios/axios#request-config
let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  method: "post",
  headers: { "content-type": "application/json" },
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    // console.log('_axios서버 통신 성공=>',response)
    return response;
  },
  function(error) {
    // alert('_axios서버 통신 오류 발생')
    console.log('_axios서버 통신 오류 발생2=>',error);
    // Do something with response error
    if (error.response && error.response.status === 403) {
      alert('페이지가 만료되었습니다. \n다시 로그인하십시요.');
      console.log("will remove cookie becuase network error");
      VueCookies.remove("auth_token");
      VueCookies.remove("account");
      VueCookies.remove("name");
      VueCookies.remove("grade");
      VueCookies.remove("menu_list");
      // window.close();
    } 
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  // window.axios = _axios; // 전역으로 노출 안시키게 주석처리

  let auth_token = VueCookies.get("auth_token");
  // console.log(auth_token)
  Vue.axios.defaults.headers.common['authorization'] = `Bearer ${auth_token}`;

  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
